import { checkPermissions } from "react/utils/utils";

Greenmile.Toolbar.Map.Layouts = {

    "#searchAddressOnMap_template": function () {
        return {
            "items": [
                {
                    "items": [
                        {
                            "tag": "input",
                            "attributes": {
                                "type": "text",
                                "id": "searchStreet",
                                "name": "searchStreet",
                                "placeholder": Monet.I18n.getResourcesByKey('RouteDetail.ToolBar.searchFieldText'),
                                class: "i18nResource"
                            }
                        },
                        {
                            "attributes": {
                                "class": "streetSearchResult",
                                "style": "display:none"
                            }
                        }
                    ],
                    "attributes": {
                        "class": "sstreetSearch"
                    }
                }
            ]
        };
    },

    "#multiSearchOnMap_template": function () {
        return {
            "items": [
                {
                    "items": [
                        {
                            "tag": "input",
                            "attributes": {
                                "type": "text",
                                "id": "searchStreet",
                                "name": "searchStreet",
                                "placeholder": Monet.I18n.getResourcesByKey('RouteDetail.ToolBar.searchFieldText'),
                                "class": "i18nResource"
                            }
                        },
                        {
                            "attributes": {
                                "class": "streetSearchResult",
                                "style": "display:none"
                            }
                        }
                    ],
                    "attributes": {
                        "class": "sstreetSearch"
                    }
                }
            ]
        };
    },

    "#street_template": function () {
        return {
            "items": [
                {
                    "attributes": {
                        "class": "btnStreetView",
                        "title": Monet.I18n.getResourcesByKey('Toolbar.hint.streetView')
                    }
                }
            ]
        };
    },

    "#zoom_template": function () {
        return {
            "items": [
                {
                    "attributes": {
                        "title": Monet.I18n.getResourcesByKey('Toolbar.hint.zoomOut'),
                        "class": "zoomOut"
                    }
                },
                {
                    "attributes": {
                        "class": "mapZoomRange"
                    }
                },
                {
                    "attributes": {
                        "title": Monet.I18n.getResourcesByKey('Toolbar.hint.zoomIn'),
                        "class": "zoomIn"
                    }
                }
            ]
        };
    },

    "#source_template": function () {
        return {
            "items": [
                {
                    "tag": "ul",
                    "items": [
                        {
                            "tag": "li",
                            "items": [
                                {
                                    "tag": "ul",
                                    "items": []
                                }
                            ]
                        }
                    ],
                    "attributes": {
                        "class": "dropdownMapSource",
                        "title": Monet.I18n.getResourcesByKey('Toolbar.hint.sourceMaps')
                    }
                }
            ]
        };
    },

    "#multiroute_template": function () {
      return {
        "items": [
          {
            "attributes": {
              "class": "btnToggleMultiroute",
              "title": Monet.I18n.getResourcesByKey('Toolbar.hint.toggleMultiRoute')
            }
          }
        ]
      };
    },

    "#pois_template": function () {
        return {
            "items": [
                {
                    "tag": "ul",
                    "items": [
                        {
                            "tag": "li",
                            "items": [
                                {
                                    "tag": "ul"
                                }
                            ]
                        }
                    ],
                    "attributes": {
                        "class": "dropdownLayer poisList",
                        "title": Monet.I18n.getResourcesByKey('Toolbar.hint.pois')
                    }
                }
            ]
        };
    },

    "#geofences_template": function () {
        return {
            "items": [
                {
                    "tag": "ul",
                    "items": [
                        {
                            "tag": "li",
                            "items": [
                                {
                                    "tag": "ul"
                                }
                            ]
                        }
                    ],
                    "attributes": {
                        "class": "dropdownLayer geofencesList",
                        "title": Monet.I18n.getResourcesByKey('Toolbar.hint.geofences')
                    }
                }
            ]
        };
    },

    "#new_layer_template": function () {
        return {
            "items": [
                {
                    "tag": "ul",
                    "items": [
                        {
                            "tag": "li",
                            "items": [
                                {
                                    "tag": "ul"
                                }
                            ]
                        }
                    ],
                    "attributes": {
                        "class": "dropdownLayer mapLayer",
                        "title": Monet.I18n.getResourcesByKey('Toolbar.hint.layerMaps')
                    }
                }
            ]
        };
    },

    "#hos_template": function () {
        if (checkPermissions("HOS_MAP")) {
            return {
                "items": [
                    {
                        "tag": "ul",
                        "items": [
                            {
                                "tag": "li",
                                "items": [
                                    {
                                        "tag": "ul"
                                    }
                                ]
                            }
                        ],
                        "attributes": {
                            "class": "dropdownLayer hos",
                            "title": Monet.I18n.getResourcesByKey('Toolbar.hint.hos')
                        }
                    }
                ]
            };
        }
    },

    "#fitToMarkers_template": function () {
        return {
            "items": [
                {
                    "attributes": {
                        "class": "btnFitToMarkers",
                        "title": Monet.I18n.getResourcesByKey('Toolbar.hint.fitToMarkers')
                    }
                }
            ]
        };
    },

    "#routePlayer_template": function (selectorId) {
        return {
            "items": [
                {
                    "items": [
                        {
                            "attributes": {
                                "class": "routePlayTime"
                            }
                        },
                        {
                            "items": [
                                {
                                    "items": [
                                        {
                                            "items": [
                                                {
                                                    "tag": "span",
                                                    "attributes": {
                                                        "class": "add-on"
                                                    }
                                                },
                                                {
                                                    "tag": "label",
                                                    "html":  Monet.I18n.getResourcesByKey('Toolbar.label.initialDate'),
                                                    "attributes": {
                                                        "for": `routePlay_initialDate_${selectorId}`
                                                    }
                                                },
                                                {
                                                    "tag": "input",
                                                    "attributes": {
                                                        "type": "text",
                                                        "value": "",
                                                        "name": "routePlay_initialDate",
                                                        "id": `routePlay_initialDate_${selectorId}`,
                                                        "class": "modelAttribute dateTimePicker "
                                                    }
                                                }
                                            ],
                                            "attributes": {
                                                "class": "controls"
                                            }
                                        }
                                    ],
                                    "attributes": {
                                        "class": "control-group"
                                    }
                                }
                            ],
                            "attributes": {
                                "class": "routePlayInitialDate"
                            }
                        },
                        {
                            "items": [
                                {
                                    "items": [
                                        {
                                            "items": [
                                                {
                                                    "tag": "span",
                                                    "attributes": {
                                                        "class": "add-on"
                                                    }
                                                },
                                                {
                                                    "tag": "label",
                                                    "html":  Monet.I18n.getResourcesByKey('Toolbar.label.finalDate'),
                                                    "attributes": {
                                                        "for": `routePlay_finalDate_${selectorId}`
                                                    }
                                                },
                                                {
                                                    "tag": "input",
                                                    "attributes": {
                                                        "type": "text",
                                                        "value": "",
                                                        "name": "routePlay_finalDate",
                                                        "id": `routePlay_finalDate_${selectorId}`,
                                                        "class": "modelAttribute dateTimePicker "
                                                    }
                                                }
                                            ],
                                            "attributes": {
                                                "class": "controls"
                                            }
                                        }
                                    ],
                                    "attributes": {
                                        "class": "control-group"
                                    }
                                }
                            ],
                            "attributes": {
                                "class": "routePlayFinalDate"
                            }
                        },
                        {
                            "items": [
                                {
                                    "attributes": {
                                        "title": Monet.I18n.getResourcesByKey('Toolbar.hint.play'),
                                        "class": "routePlayGo"
                                    }
                                },
                                {
                                    "attributes": {
                                        "title": Monet.I18n.getResourcesByKey('Toolbar.hint.clearDates'),
                                        "class": "routePlayGoToLast"
                                    }
                                }
                            ],
                            "attributes": {
                                "class": "routePlayControls"
                            }
                        }
                    ],
                    "attributes": {
                        "class": "routePlay"
                    }
                }
            ]
        };
    },

    "#tags_template_equipment": function () {
        return {
            "items": [
                {
                    "tag": "ul",
                    "items": [
                        {
                            "tag": "li",
                            "items": [
                                {
                                    "tag": "ul"
                                }
                            ]
                        }
                    ],
                    "attributes": {
                        "class": "dropdownLayer tagsContainer tagsEquipment",
                        "title": Monet.I18n.getResourcesByKey('Toolbar.hint.tags.equipment')
                    }
                }
            ]
        };
    },
    "#tags_template_geofence": function () {
        return {
            "items": [
                {
                    "tag": "ul",
                    "items": [
                        {
                            "tag": "li",
                            "items": [
                                {
                                    "tag": "ul"
                                }
                            ]
                        }
                    ],
                    "attributes": {
                        "class": "dropdownLayer tagsContainer tagsGeofence",
                        "title": Monet.I18n.getResourcesByKey('Toolbar.hint.tags.geocode')
                    }
                }
            ]
        };
    },

    "#config_info_marker_truck": function () {
        return {
            "items": [
                {
                    "tag": "ul",
                    "items": [
                        {
                            "tag": "li",
                            "items": [
                                {
                                    "tag": "ul",
                                    items: [
                                        {
                                            "attributes": {
                                                "class": "listOrganization"
                                            }
                                        }
                                    ]
                                }
                            ]
                        }
                    ],
                    "attributes": {
                        "class": "dropdownLayer configInfoMarkerTruck",
                        "title": Monet.I18n.getResourcesByKey('Toolbar.hint.makerConfig')
                    }
                }
            ]
        };
    },

    "#config_info_events": function () {
        return {
            "items": [
                {
                    "tag": "ul",
                    "items": [
                        {
                            "tag": "li",
                            "items": [
                                {
                                    "tag": "ul",
                                    items: [
                                        {
                                            "attributes": {
                                                "class": "listEvents"
                                            }
                                        }
                                    ]
                                }
                            ]
                        }
                    ],
                    "attributes": {
                        "class": "dropdownLayer events",
                        "title": Monet.I18n.getResourcesByKey('Toolbar.hint.events')
                    }
                }
            ]
        };
    },

    "#focusEquipment_template": function () {
        return {
            "items": [
                {
                    "attributes": {
                        "class": "btnFocusEquipment",
                        "title": Monet.I18n.getResourcesByKey('Toolbar.hint.focusEquipment')
                    }
                }
            ]
        };
    },

    "#equipamentOff_template": function () {
        return {
            "items": [
                {
                    "tag": "ul",
                    "items": [
                        {
                            "tag": "li",
                            "items": [
                                {
                                    "tag": "ul",
                                    items: [
                                        {
                                            "tag": "li",
                                            items: [
                                                {
                                                    items: [
                                                        {
                                                            attributes: {
                                                                "class": "labelMin"
                                                            },
                                                            html: Monet.I18n.getResourcesByKey('RouteDetail.equipmentOff.min')
                                                        },
                                                        {
                                                            tag: "input",
                                                            attributes: {
                                                                "type": "text",
                                                                "id": "inputEquipOff",
                                                                "name": "inputEquipOff",
                                                                "class": "layerEquipmentOff timerPicker",
                                                                "value": "60"
                                                            }
                                                        },
                                                        {
                                                            "items": [
                                                                {
                                                                    tag: "input",
                                                                    attributes: {
                                                                        "id": "buttonEquipOff",
                                                                        type: "button",
                                                                        "name": "buttonEquipOff",
                                                                        "class": "layerEquipmentOff",
                                                                        "value": Monet.I18n.getResourcesByKey("default.button.filter"),
                                                                        "style": "float:right;"
                                                                    }
                                                                },
                                                                {
                                                                    tag: "input",
                                                                    attributes: {
                                                                        "id": "cancelEquipOff",
                                                                        type: "button",
                                                                        "name": "cancelEquipOff",
                                                                        "class": "layerEquipmentOff",
                                                                        "value": Monet.I18n.getResourcesByKey("default.button.clear")
                                                                    }
                                                                }
                                                            ],
                                                            "attributes": {
                                                                "class": "standard-form-buttons"
                                                            }
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ],
                    "attributes": {
                        "class": "dropdownLayer layerEquipOff",
                        "title": Monet.I18n.getResourcesByKey('Toolbar.hint.timeStopped')
                    }
                }
            ]
        };
    },

    "#item_pois_template": function (poiId, poiDescription, routeReference) {
        var layout = {
            "items": [
                {
                    "tag": "li",
                    "items": [
                        {
                            "items": [
                                {
                                    "tag": "input",
                                    "attributes": {
                                        "type": "checkbox",
                                        "id": `poiItem-${routeReference}_${poiId}`,
                                        "name": "layerLocations",
                                        "class": "layerMaps",
                                        "value": poiDescription
                                    }
                                }
                            ],
                            "attributes": {
                                "class": "radio"
                            }
                        },
                        {
                            "items": [
                                {
                                    "tag": "label",
                                    "items": [
                                        {
                                            "tag": "span",
                                            "attributes": {
                                                "class": "i18nResource"
                                            },
                                            html: poiDescription
                                        }
                                    ],
                                    "attributes": {
                                        "for": `poiItem-${routeReference}_${poiId}`
                                    }
                                }
                            ],
                            "attributes": {
                                "class": "text"
                            }
                        }
                    ],
                    "attributes": {
                        "class": "locationTypeItem"
                    }
                }
            ]
        };
        var generator = new Monet.UI.LayoutGenerator(layout);
        return generator.render();
    },

    "#item_tags_template": function (id, tagsClass, description, tagColor) {
        var layout = {
            "items": [
                {
                    "tag": "li",
                    "items": [
                        {
                            "items": [
                                {
                                    "tag": "input",
                                    "attributes": {
                                        "type": "checkbox",
                                        "id": id,
                                        "class": tagsClass,
                                        "value": description
                                    }
                                }
                            ],
                            "attributes": {
                                "class": "radio"
                            }
                        },
                        {
                            "items": [
                                {
                                    "tag": "label",
                                    "items": [
                                        {
                                            "tag": "span",
                                            "attributes": {
                                                "class": "i18nResource"
                                            },
                                            html: description
                                        }
                                    ],
                                    "attributes": {
                                        "for": id
                                    }
                                }
                            ],
                            "attributes": {
                                "class": "text"
                            }
                        },
                        {
                            "attributes": {
                                "class": "colorField",
                                "style": "background: " + tagColor + ";"
                            }
                        }
                    ]
                }
            ]
        };
        var generator = new Monet.UI.LayoutGenerator(layout);
        return generator.render();
    },

    "#item_hos_template": function (hostype, hosDescription, routeReference) {
        var layout = {
            "items": [
                {
                    "tag": "li",
                    "items": [
                        {
                            "items": [
                                {
                                    "tag": "input",
                                    "attributes": {
                                        "type": "checkbox",
                                        "id": `hos-${hostype}-${routeReference}`,
                                        "name": "layerLocations",
                                        "class": "hosItens",
                                        "value": "routes"
                                    }
                                }
                            ],
                            "attributes": {
                                "class": "radio"
                            }
                        },
                        {
                            "items": [
                                {
                                    "tag": "label",
                                    "items": [
                                        {
                                            "tag": "span",
                                            "attributes": {
                                                "class": "i18nResource"
                                            },
                                            html: hosDescription
                                        }
                                    ],
                                    "attributes": {
                                        "for": `hos-${hostype}-${routeReference}`
                                    }
                                }
                            ],
                            "attributes": {
                                "class": "text"
                            }
                        }
                    ]
                }
            ]
        };
        var generator = new Monet.UI.LayoutGenerator(layout);
        return generator.render();
    },

    "#points_template": function () {
        return {
            "items": [
                {
                    "tag": "ul",
                    "items": [
                        {
                            "tag": "li",
                            "items": [
                                {
                                    "tag": "ul",
                                    "items": [
                                        {
                                            "tag": "li",
                                            "items": [
                                                {
                                                    "items": [
                                                        {
                                                            "attributes": {
                                                                "class": "mapsToolbarPointsDistanceIco"
                                                            }
                                                        }
                                                    ],
                                                    "attributes": {
                                                        "class": "icon"
                                                    }
                                                },
                                                {
                                                    "items": [
                                                        {
                                                            "tag": "span",
                                                            "html": Monet.I18n.getResourcesByKey('RouteDetail.ToolBar.pointsToDistance'),
                                                            "attributes": {
                                                                "class": "i18nResource"
                                                            }
                                                        }
                                                    ],
                                                    "attributes": {
                                                        "class": "text"
                                                    }
                                                }
                                            ],
                                            "attributes": {
                                                "class": "Pointsdistance"
                                            }
                                        }
                                    ]
                                }
                            ]
                        }
                    ],
                    "attributes": {
                        "class": "dropdownMeasurement",
                        "title": Monet.I18n.getResourcesByKey('Toolbar.hint.coordinates')
                    }
                }
            ]
        };
    },

    "#coords_template": function () {
        return {
            "items": [
                {
                    "tag": "li",
                    "items": [
                        {
                            "items": [
                                {
                                    "attributes": {
                                        "class": "mapsToolbarCoordsDistanceIco"
                                    }
                                }
                            ],
                            "attributes": {
                                "class": "icon"
                            }
                        },
                        {
                            "items": [
                                {
                                    "tag": "span",
                                    "html": Monet.I18n.getResourcesByKey('RouteDetail.ToolBar.coordsDistance'),
                                    "attributes": {
                                        "class": "i18nResource"
                                    }
                                }
                            ],
                            "attributes": {
                                "class": "text"
                            }
                        }
                    ],
                    "attributes": {
                        "class": "Coordsdistance"
                    }
                }
            ]
        };
    }
};
